import $ from 'jquery';
import domReady from '@wordpress/dom-ready';
import { _x } from '@wordpress/i18n';

domReady(() => {
  const toggles = $('.biography-toggle');

  if (0 < toggles.length) {
    toggles.each(function () {
      $(this).on('click', function () {
        const content = $($(this).attr('aria-controls'));
        if ($(this).hasClass('expanded')) {
          $(this).removeClass('expanded');
          $(this)
            .find('.label')
            .text(_x('Read more', 'toggle label when closed', 'vtx'));
          content.slideUp();
        } else {
          $(this).addClass('expanded');
          $(this)
            .find('.label')
            .text(_x('Read less', 'toggle label when closed', 'vtx'));
          content.slideDown();
          content.focus();
        }
      });
    });
  }
});
